import {SqlParam} from '../../sql/message/SqlParam';

export class LogWriterConfiguration {
exitStatusOnLog: boolean | null;
params: SqlParam[];
schema: string;
tableName: string;
updateMode: boolean | null;
}

